
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { TostMsg } from "../../../../App";
import { Carousel } from "primereact/carousel";
import { LazyVideo } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Mention } from "primereact/mention";
import { getTrans as T } from "../../../../Shared/Language";
import $ from "jquery";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import { postFeed } from "../Services/DashboardServices";
import EmojiPicker from "emoji-picker-react";
import { useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import ImageCropperModalMulti from "../../../../Services/Comment/ImageCropperModalMulti";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
import LoginLoader from "../../../../Shared/Sidebar/LoginLoader";

const FeedPost = ({ returnResponce, editFeedLst, isActiveFeedPost, onClose }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const [ImagePath, setImagePath] = useState([]);
  const [mentionedArr, setMentionedArr] = useState([]);
  const [multipleSuggestions, setMultipleSuggestions] = useState([]);
  const [feedText, setFeedText] = useState("");
  const toster = useContext(TostMsg);
  const [file, setFile] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [isVisibleEmoji, setisVisibleEmoji] = useState(false);
  const defaultImage = "/images/placeholder_profile.png";
  const feedDefaultImage = "/images/no-data-found/feed_dummy.png";
  const dispatch = useDispatch();
  let history = useHistory();
  const [imageSrc, setImageSrc] = useState(null); // for single image
  const [multiImageSrcs, setMultiImageSrcs] = useState([]); // for multiple
  const [showCropper, setShowCropper] = useState(false);
  const [acceptRatio, setAcceptRatio] = useState(1 / 1);
  const videoFilesRef = useRef([]);
  const [isVisible, setIsVisible] = useState(false);
  const [posterSrc, setPosterSrc] = useState("");
  const [fileSizeError, setFileSizeError] = useState("");
  const pickerRef = useRef(null);
  const tagSuggestions = [
    "instagood",
    "photooftheday",
    "beautiful",
    "art",
    "photography",
    "happy",
    "picoftheday",
    "cute",
    "follow",
    "followme",
    "nature",
    "like4like",
    "travel",
    "instagram",
    "style",
    "repost",
    "summer",
    "instadaily",
    "selfie",
    "me",
    "friends",
    "fitness",
    "girl",
    "food",
    "fun",
    "beauty",
    "instalike",
    "smile",
    "family",
    "photo",
    "life",
    "likeforlike",
    "music",
    "ootd",
    "follow4follow",
    "makeup",
    "amazing",
    "igers",
    "nofilter",
    "dog",
    "model",
    "sunset",
    "beach",
  ];
  const [isDragFile, setIsDraggingFile] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setisVisibleEmoji(false); // hide picker when clicked outside
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {

    if (editFeedLst != "reset") {
      let NewMedia = editFeedLst?.PostMedia?.map((emp) => ({
        MediaPath: emp?.MediaPath,
        MediaName: "image/jpeg",
      }));
      setImagePath(NewMedia);
      setFeedText(editFeedLst?.FeedText);
      let NewSuggestion = editFeedLst?.PostMentions?.map((emp) => ({
        MentionedName: emp?.FullName ?? emp?.MentionedName ?? "",
        MentionedId: emp?.MentionedId ?? 0,
        CommentId: 0,
      }));
      if (JSON.stringify(mentionedArr) !== JSON.stringify(NewSuggestion)) {
        setMentionedArr(NewSuggestion);
      }
    } else if (editFeedLst == "reset") {
      ResetFeedFields();
    } else {
      fetchData();
    }
  }, [editFeedLst]);

  useEffect(() => {
    if (editFeedLst?.FeedText ?? editFeedLst?.PostMedia) {
      setIsVisible(true);
    } else if (feedText) {
      setIsVisible(true);
    } else if (ImagePath?.length) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [editFeedLst, feedText, ImagePath]);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);
  const handleImageFeedError = useCallback((event) => {
    event.target.src = feedDefaultImage;
  }, []);

  useEffect(() => {
    fetchData();
    if (isActiveFeedPost) {
      const modalEl = document.getElementById("feed-org");
      if (modalEl && window.bootstrap) {
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }
    }
  }, [isActiveFeedPost]);

  useEffect(() => {
    const modalEl = document.getElementById("feed-org");
    if (!modalEl) return;
    // when the bootstrap modal is fully hidden, notify parent so it can reset state
    const handleHidden = () => {
      if (typeof onClose === "function") onClose();
    };
    modalEl.addEventListener("hidden.bs.modal", handleHidden);
    return () => modalEl.removeEventListener("hidden.bs.modal", handleHidden);
  }, [onClose]);

  const fetchData = async () => {
    await fetchEmployeeData();
  };

  const PostFeed = useCallback(async () => {
    setIsloading(true);
    if (mentionedArr != undefined) {
      const body = {
        Id: editFeedLst?.Id ?? 0,
        EmpId: userDetails?.EmpId,
        FeedText: feedText,
        IsCommentEnabled: true,
        IsLikeCountVisible: true,
        CommentVisible: true,
        IsLikeEnabled: true,
        PostMedia: ImagePath,
        PostMentions: mentionedArr,
      };
      try {
        await postFeed(body);
        document.querySelector("#feed-org .btn-close")?.click();
        toster.current.success("Feed post successfully.");
        history?.push("/Dashboard");
        returnResponce("feedUpdated");
        setImagePath((image) => (image, []));
        setMentionedArr((mention) => (mention, []));
        setFeedText("");
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST?.DashboardFeaturePost);
      }
    } else {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }, [mentionedArr, ImagePath, feedText]);
  const ResetFeedFields = () => {
    $(".input-Btn")?.hide("slow");
    setFileSizeError("");
    setImagePath((image) => (image, []));
    setMentionedArr((mention) => (mention, []));
    setFeedText("");
  };
  useEffect(() => { }, [feedText]);
  const getFeedText = useCallback(
    (event) => {
      setFeedText((text) => (text, event.target.value));
    },
    [feedText],
  );

  let EmojiArr = [];
  const onEmojiClick = (emojiObject) => {
    let textId = document.getElementById("feedareatexts");
    const start = textId.selectionStart;
    const end = textId.selectionEnd;
    EmojiArr.push(...emojiObject.emoji);
    const netText =
      textId.value.slice(0, start) + EmojiArr[0] + textId.value.slice(start);
    textId.value = netText;
    const newCursorPosition = start + EmojiArr[0].length;
    textId.setSelectionRange(newCursorPosition, newCursorPosition);
    textId.focus();
    setFeedText(netText);
  };
  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployee(employeesList.Data);
    } catch (error) { }
  }

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  function showPopup() {
    if (ImagePath?.length == 0) {
      $(".upload-img")?.show("slow");
      $(".input-Btn")?.hide("slow");
    } else {
      fileImageInputRef.current?.click();
      // $(".input-Btn")?.show("slow");

      // $(".upload-img")?.hide("slow");
    }
  }
  function hidePopup() {
    $(".input-Btn")?.hide("slow");
    $(".upload-img")?.hide("slow");
  }

  useEffect(() => {
    const video = document.getElementById("videoElement");
    if (video) {
      video.addEventListener("loadeddata", () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const poster = canvas.toDataURL("image/jpeg");
        setPosterSrc(poster);
      });
    }
  }, []);

  const UploadedMediaTemplate = (media, index) => {
    return (
      <div className="border-1 surface-border border-round m-2 text-center">
        <div className="mb-3">
          {media?.MediaPath?.endsWith(".mp4") ||
            media?.MediaPath?.toLowerCase()?.endsWith(".mov") ? (
            <div key={index} className="videoContainer">
              <a
                onClick={() => DeleteUploadedImage(index)}
                className="text-danger"
              >
                x
              </a>
              <LazyVideo
                id="videoElement"
                src={`${media?.MediaPath}`}
                poster={posterSrc}
                playsInline
                muted
                controls
              />
            </div>
          ) : (
            <div key={index} className="uploaded-imgtrash">
              <a
                onClick={() => DeleteUploadedImage(index)}
                className="text-danger"
              >
                x
              </a>
              <img
                src={`${media?.MediaPath || defaultImage}`}
                onError={handleImageFeedError}
                alt="Description of the image"
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  const DeleteUploadedImage = (index) => {
    const newCardList = [...ImagePath];
    newCardList.splice(index, 1);
    setImagePath(newCardList);
    if (ImagePath.length == 1) {
      $(".upload-img").show("slow");
      $(".input-Btn").hide("slow");
    }
    // else {
    //   $(".input-Btn").show("slow");
    //   $(".upload-img").hide("slow");
    // }
  };

  const multipleItemTemplate = (suggestion, options) => {
    const trigger = options.trigger;
    if (trigger === "@" && suggestion.FullName) {
      return itemTemplate(suggestion);
    } else if (trigger === "#" && !suggestion.FullName) {
      return <span>{suggestion}</span>;
    }
    return null;
  };

  const onSelectHandler = useCallback((e) => {
    let selectedMention = {
      MentionedName: e.suggestion?.FullName ?? "",
      MentionedId: e.suggestion?.Id ?? 0,
      CommentId: 0,
    };

    setMentionedArr((prevSelectedData) => {
      const exists = prevSelectedData.some(
        (item) => item.MentionedId === selectedMention.MentionedId,
      );
      if (exists) return prevSelectedData;

      return [...prevSelectedData, selectedMention];
    });
  }, []);


  const dragCounter = useRef(0);
  const handleDragEnter = (e) => {
    e.preventDefault();
    dragCounter.current += 1;
    setIsDraggingFile(true);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDraggingFile(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    dragCounter.current -= 1;

    if (dragCounter.current === 0) {
      setIsDraggingFile(false);
    }
  };

  const fileImageInputRef = useRef(null);
  function openSelectImageInput() {
    fileImageInputRef.current.click();
  }

  const fileInputRef = useRef(null);
  function openFileInput() {
    fileInputRef.current?.click();
  }

  const handleFileImageChange = async (event) => {
    const files = Array.from(event.target.files);
    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const oversizedFiles = files.filter((file) => file.size > MAX_FILE_SIZE);
    if (!files.length) return;

    if (oversizedFiles.length <= 0) {
      setFileSizeError("");
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));
      const videoFiles = files.filter((file) => file.type.startsWith("video/"));

      videoFilesRef.current = videoFiles;
      if (imageFiles.length > 0) {
        try {
          const imageDataURLs = await Promise.all(
            imageFiles.map((file) => {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
              });
            }),
          );

          if (imageDataURLs.length > 0) {
            setImageSrc(null);
            setMultiImageSrcs(imageDataURLs);
            setAcceptRatio(1 / 0.6);
            setShowCropper(true);
          }
        } catch (err) {
          console.error("Failed to read image files", err);
        }
      } else if (videoFiles.length > 0) {
        setFile(videoFiles);
        videoFilesRef.current = [];
      }

      fileInputRef.current.value = "";
    } else {
      setFileSizeError("File too large. Maximum size: 20 MB.");
    }
  };

  const handleCropComplete = (croppedData) => {
    const blobs = Array.isArray(croppedData) ? croppedData : [croppedData];
    const croppedFiles = blobs.map(
      (blob, index) =>
        new File([blob], `cropped-${index + 1}.jpg`, { type: "image/jpeg" }),
    );
    const finalFiles = [...croppedFiles, ...videoFilesRef.current];
    setFile(finalFiles);
    videoFilesRef.current = [];
  };

  useEffect(() => {
    if (file?.length > 0) {
      uploadMediaFile();
    }
  }, [file]);

  async function uploadMediaFile() {
    setIsloading(true);
    if (file && file.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Feed,
        RefId: editFeedLst?.Id ?? 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        $(".upload-img").hide("slow");
        $(".input-Btn").show("slow");
        if (ImageURL && ImageURL.length > 0) {
          const processedMedia = [];
          for (let i = 0; i < ImageURL.length; i++) {
            const media = ImageURL[i];
            const currentFile = file[i];
            if (media.slice(-3) === "mp4" || media.slice(-3) === "mov") {
              const duration = await getVideoDuration(media);
              processedMedia.push({
                MediaPath: media,
                MediaName: "",
              });
              setIsloading(false);
            } else {
              processedMedia.push({
                MediaPath: media,
                MediaName: String(currentFile.type),
              });
              setIsloading(false);
            }
          }
          setImagePath((prev) => [...prev, ...processedMedia]);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setIsloading(false);
      }
    } else {
      setIsloading(false);
      toster.current.warn("No file selected.");
    }
  }

  function getVideoDuration(mediaPath) {
    return new Promise((resolve) => {
      const videoElement = document.createElement("video");
      videoElement.src = mediaPath;
      videoElement?.addEventListener("loadedmetadata", () => {
        resolve(videoElement.duration);
      });
    });
  }

  const onMultipleSearch = (event) => {
    const trigger = event?.trigger;
    if (trigger === "@") {
      setTimeout(() => {
        const query = event?.query;
        let suggestions;
        if (!query.trim()?.length) {
          suggestions = [...employee];
        } else {
          suggestions = employee?.filter((customer) => {
            return customer?.FullName.toLowerCase()?.startsWith(
              query?.toLowerCase(),
            );
          });
        }
        setMultipleSuggestions(suggestions);
      }, 250);
    } else if (trigger === "#") {
      setTimeout(() => {
        const query = event.trigger;
        let suggestions;

        if (!query.trim().length) {
          suggestions = [...tagSuggestions];
        } else {
          suggestions = tagSuggestions.filter((tag) => {
            return tag.toLowerCase();
          });
        }
        setMultipleSuggestions(suggestions);
      }, 250);
    }
  };

  const itemTemplate = (suggestion) => {
    const src = suggestion.ProfileImage;
    return (
      <div className="flex align-items-center">
        <img
          alt={suggestion.FullName || defaultImage}
          onError={handleImageError}
          src={src}
          th="32"
          style={{ maxWidth: "10%", height: "auto" }}
        />
        <span className="flex flex-column ml-2">{suggestion.FullName}</span>
      </div>
    );
  };

  const handleDrop = (event) => {
    event.preventDefault();
    dragCounter.current = 0;
    setIsDraggingFile(false);
    const files = event?.dataTransfer?.files;
    if (files.length) {
      setFile(files);
    }
  };

  return (
    <>
      <div className="col-xl-12 mobiletabs">
        <div className="">
          <div className="card-body">
            <ul>
              <li>
                <a href="#feeds">
                  <img src="/images/menu-icon/feeds.png" />
                  Feeds
                </a>
              </li>
              <li>
                <a href="#upcomings">
                  <img src="/images/menu-icon/celebrate.png" />
                  Love
                </a>
              </li>
              <li>
                <a href="#info">
                  <img src="/images/menu-icon/info.png" />
                  Info
                </a>
              </li>
              <li>
                <a href="#more">
                  <img src="/images/menu-icon/more.png" />
                  More
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {isActiveFeedPost && <div className="modal fade" id="feed-org">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Share your thoughts</h5>
              <button
                onClick={() => ResetFeedFields()}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body p-2">
              <div className="add-postpopup-modal">
                <div className="image">
                  <img
                    src={userDetails?.ProfileImage || defaultImage}
                    onError={handleImageError}
                    data-demo-src="/images/main-body/1.jpg"
                    data-user-popover="1"
                    alt=""
                  />
                </div>
                <div className="feed-div">
                  <div className="flex justify-content-center">
                    <Mention
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trimStart(); // trims leading spaces only
                        setFeedText(trimmedValue);
                      }}
                      onBlur={(e) => {
                        setFeedText(e.target.value.trim()); // trims both ends when losing focus
                      }}
                      className={"w-100"}
                      value={feedText}
                      inputId="feedareatexts"
                      onSelect={onSelectHandler}
                      onFocus={(e) => {
                        getFeedText(e);
                      }}
                      // onChange={(e) => {
                      //   getFeedText(e);
                      // }}
                      trigger={["@", "#"]}
                      suggestions={multipleSuggestions}
                      onSearch={onMultipleSearch}
                      field={["FullName"]}
                      placeholder="Enter @ to mention people, # to mention tag"
                      itemTemplate={multipleItemTemplate}
                      rows={8}
                      cols={100}
                      maxLength={2000}
                    />
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      fontSize: "12px",
                      // position: "absolute",
                      // right: "27px",
                      bottom: "1px",
                      color: feedText?.length >= 2000 ? "red" : "#555",
                    }}
                  >
                    {feedText?.length || 0}/2000
                  </div>
                  <div className="upload-emoji">
                    <span>Smileys </span>
                    <img
                      src="/images/org-img/close.png"
                      className="Hide-upload-div2"
                    />
                    <div>
                      <ul className="emoji-ul">
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-smile-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-heart-eyes-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-laughing-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-expressionless-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-smile-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-heart-eyes-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-laughing-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-expressionless-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-smile-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-heart-eyes-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-laughing-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-expressionless-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
                          </svg>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* // )} */}
              </div>
              <div className="col-lg-9">
                <div className="fs-13 text-danger">{fileSizeError}</div>
              </div>
              {Isloading ? (
                <Skeleton height={270} width="100%" />
              ) : (
                <div>
                  <div className="upload-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-x-square-fill Hide-upload-div"
                      onClick={() => hidePopup()}
                      viewBox="0 0 16 16"
                    >
                      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708" />
                    </svg>
                    <img
                      src="/images/org-img/upload.png"
                      alt="upload"
                      className="w-100"
                      onDragEnter={handleDragEnter}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      onClick={openSelectImageInput}
                    />
                  </div>
                  {showCropper && (
                    <ImageCropperModalMulti
                      image={imageSrc}
                      images={multiImageSrcs}
                      acceptRatio={acceptRatio}
                      onComplete={handleCropComplete}
                      onClose={() => setShowCropper(false)}
                    />
                  )}
                  <div className="input-Btn add-more-pictures w-100">
                    <div className="row align-items-center">
                      <div className="col-lg-3">
                        <p style={{ cursor: "pointer" }} className="mr-3">
                          Add More
                        </p>
                      </div>
                    </div>
                    <input
                      className="input-Btn"
                      name="file"
                      type="file"
                      accept="image/*,video/mp4, video/quicktime"
                      onChange={handleFileImageChange}
                      id="fileInput"
                      ref={fileImageInputRef}
                      multiple
                      onClick={openFileInput}
                      onDragEnter={handleDragEnter}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      style={{ opacity: "0" }}
                    />
                  </div>
                </div>
              )}

              {ImagePath && ImagePath.length !== 0 ? (
                <div
                  className={`upload-imgCarousel ${isDragFile ? "drag-bulk-active" : ""}`}
                >
                  <Carousel
                    value={ImagePath}
                    numVisible={3}
                    numScroll={3}
                    className="custom-carousel"
                    responsiveOptions={responsiveOptions}
                    circular
                    autoplayInterval={3000}
                    itemTemplate={(media) =>
                      UploadedMediaTemplate(media, ImagePath.indexOf(media))
                    }
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  />
                </div>
              ) : (
                ""
              )}
              <div className="actions">
                <ul className="d-flex p-0 m-0">
                  <li className="Show-upload-div" onClick={showPopup}>
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="text-success pe-2"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"></path>
                    </svg>
                    Photos / Videos
                  </li>
                  <li
                    className="Show-upload-div "
                    onClick={() => setisVisibleEmoji(!isVisibleEmoji)}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="text-warning pe-2"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8"></path>
                    </svg>
                    Feelings/Activity
                  </li>
                </ul>
                {isVisibleEmoji && (
                  <div ref={pickerRef}>
                    <EmojiPicker onEmojiClick={onEmojiClick} />
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer footer-feed">
              <button
                type="submit"
                disabled={!isVisible}
                onClick={PostFeed}
                className="btn position-relative"
              >
                {T("Post")}
                {Isloading ? <LoginLoader /> : ""}
              </button>
            </div>
          </div>
        </div>
      </div>}
    </>
  );
};
export default FeedPost;
